import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { cn } from './ui/Button';

export const QuestionCard = ({ question, currentIndex, total, onSelect }) => {
  const [selectedIdx, setSelectedIdx] = useState(null);

  const handleSelect = (idx) => {
    if (selectedIdx !== null) return;
    setSelectedIdx(idx);
    onSelect(idx);
  };

  return (
    <motion.div
      initial={{ opacity: 0, x: 20 }}
      animate={{ opacity: 1, x: 0 }}
      exit={{ opacity: 0, x: -20 }}
      transition={{ duration: 0.3 }}
      className="w-full max-w-md mx-auto"
    >
      <div className="glass-panel rounded-3xl p-6 sm:p-8">
        <div className="text-sm font-medium text-[#d2ff02] mb-4">
          Question {currentIndex + 1} of {total}
        </div>
        <h2 className="text-2xl sm:text-3xl font-bold mb-8 text-white leading-tight">
          {question.text}
        </h2>
        <div className={`space-y-3 ${selectedIdx !== null ? 'pointer-events-none' : ''}`}>
          {question.options.map((option, idx) => (
            <button
              key={idx}
              onClick={() => handleSelect(idx)}
              className={cn(
                "w-full text-left p-4 rounded-xl transition-all duration-200",
                "bg-slate-800/50 border border-slate-700/50",
                "active:scale-[0.98] group flex items-center justify-between",
                selectedIdx === idx 
                  ? "border-[#d2ff02] bg-[#d2ff02]/10 ring-1 ring-[#d2ff02]/50" 
                  : "hover:bg-slate-700/80 hover:border-[#0094f7]/50"
              )}
            >
              <span className={cn(
                "font-medium transition-colors",
                selectedIdx === idx ? "text-[#d2ff02]" : "text-slate-200 group-hover:text-white"
              )}>
                {option}
              </span>
              <div className={cn(
                "w-5 h-5 rounded-full border-2 transition-colors",
                selectedIdx === idx 
                  ? "border-[#d2ff02] bg-[#d2ff02] shadow-[0_0_10px_#d2ff02]" 
                  : "border-slate-600 group-hover:border-[#d2ff02]"
              )} />
            </button>
          ))}
        </div>
      </div>
    </motion.div>
  );
};